import { render, staticRenderFns } from "./WorkgroupFilters.vue?vue&type=template&id=2e0bad2b&"
import script from "./WorkgroupFilters.vue?vue&type=script&lang=js&"
export * from "./WorkgroupFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports